<template>
  <div>
    <ValidationObserver ref="observer">
      <form>
        <div class="row">
          <div class="form-group col">
            <label>Mail template</label>
            <div>{{ name }}</div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-4">
            <label>Mail send date</label>
            <ValidationProvider v-if="!contents.isImmediately" rules="required" v-slot="{ errors }">
              <DatetimeInput v-model="contents.datetime" :minuteInterval="10"/>
              <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
            </ValidationProvider>
          </div>
          <div class="form-group col-4">
            <label>Immediately</label>
            <div>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input type="checkbox" v-model="contents.isImmediately" />
                <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col">
            <label>Mail Subject</label>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input type="text" class="form-control" v-model="contents.subject" />
              <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="form-group col">
            <label>Mail Text</label>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <Textarea class="form-control" v-model="contents.body" :rows="20" />
              <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
            </ValidationProvider>
          </div>
        </div>
      </form>
    </ValidationObserver>

    <div class="d-flex justify-content-end">
      <b-button pill variant="secondary" class="mr-2" @click="back">
        Back
      </b-button>
      <b-button pill variant="primary" @click="next">
        Confirm
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Moment } from 'moment'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { Component, Prop, Vue } from 'vue-property-decorator'
import DatetimeInput from '@/components/parts/inputItem/DatetimeInput.vue'
import Textarea from '@/components/parts/inputItem/Textarea.vue'

export interface MailContents {
  datetime: Moment|null
  isImmediately: boolean
  subject: string
  body: string
}

@Component({
  components: {
    DatetimeInput,
    Textarea,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class MailsSendBulkMailInput extends Vue {
  @Prop({ required: true }) value!: MailContents|undefined

  @Prop({ required: true }) name!: string

  private created() {
    if (this.value === undefined) {
      this.$emit('input', {
        datetime: null,
        isImmediately: false,
        subject: '',
        body: '',
      })
    }
  }

  private get contents(): MailContents {
    return this.value || {
      datetime: null,
      isImmediately: false,
      subject: '',
      body: '',
    }
  }

  private set contents(mailContents: MailContents) {
    this.$emit('input', mailContents)
  }

  private back() {
    this.$emit('back')
  }

  private async next() {
    const isOk = await (this.$refs.observer as any).validate()
    if (isOk) {
      this.$emit('next')
    } else {
      this.$bvModal.msgBoxOk('Please fix errors')
    }
  }
}
</script>

<style>

</style>
